import { render, staticRenderFns } from "./ThePageNotFoundLayout.vue?vue&type=template&id=4e3b6db8&scoped=true"
import script from "./ThePageNotFoundLayout.vue?vue&type=script&lang=js"
export * from "./ThePageNotFoundLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3b6db8",
  null
  
)

export default component.exports